import React from "react";
import "./Header.css";
import Logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
import { useState } from "react";
import { Link } from "react-scroll";

const Header = () => {
  const mobile = window.innerWidth <= 768 ? true : false;
  const [menu, setMenu] = useState(false);
  return (
    <div className="header">
      <img className="logo" src={Logo} alt="" />
      {menu === false && mobile === true ? (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px",
          }}
          onClick={() => setMenu(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1rem" }}
          ></img>
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
              activeClass="active"
              to="home"
              span={true}
              smooth={true}
              onClick={() => setMenu(false)}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="programs"
              span={true}
              smooth={true}
              onClick={() => setMenu(false)}
            >
              Programs
            </Link>
          </li>
          <li>
            <Link
              to="Reasons"
              span={true}
              smooth={true}
              onClick={() => setMenu(false)}
            >
              Why Us
            </Link>
          </li>
          <li>
            <Link
              to="plan-container"
              span={true}
              smooth={true}
              onClick={() => setMenu(false)}
            >
              Plans
            </Link>
          </li>
          <li>
            <Link
              to="Testimonials"
              span={true}
              smooth={true}
              onClick={() => setMenu(false)}
            >
              Testimonials
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
